import React from "react";
import {Link} from "react-router-dom";
import Links from "../../../components/Links";
import Scrollchor from "react-scrollchor";

export default () =>(
    <header id="header">
        <h1 id="logo">
            <Link to={'/'}>Ispire</Link>

        </h1>
        <nav id="nav">
            <ul>
                <li><a href="https://github.com/Ispirett">
                    <img
                        src=" https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
                        alt="github"
                        className={"icon-2"}
                    />
                </a></li>
                <li><a href="https://www.linkedin.com/in/isaac-browne/">
                    <img
                        src="https://image.flaticon.com/icons/png/512/145/145807.png"
                        alt="github"
                        className={"icon-2"}
                    />
                </a></li>
                <li><a href="https://angel.co/isaac-browne">
                    <img
                        src="https://cdn3.iconfinder.com/data/icons/ultimate-social/150/47_angel_list-512.png"
                        alt="github"
                        className={"icon-2"}
                    />
                </a>
                </li>

                <li><a href="https://stackoverflow.com/users/9952223/ispirett?tab=profile">
                    <img
                        src="https://icon2.kisspng.com/20180616/ibu/kisspng-stack-overflow-stack-exchange-computer-icons-progr-reen-5b25a9c1deea65.7379467415291949459131.jpg"
                        alt="github"
                        className={"icon-2"}
                    />
                </a>
                </li>


                <li><Link to={'/'}>Home</Link></li>
                <li>

                    <Scrollchor
                        to={"#projects"}
                        animate={{offset: 20, duration: 600}}
                    >
                      projects
                    </Scrollchor>
                    <ul>
                        <li>
                            <a href="#">Contact Me</a>
                        </li>
                    </ul>
                </li>

                {/*<li><a href="#" className="button primary">linkedin</a></li>*/}
            </ul>
        </nav>
    </header>

)